import * as SavedListActionTypes from '../actionTypes/SavedListActionTypes';

export const getSavedLists = (
    listId,
    page,
    limit,
    sort,
    deviceType,
    data,
    token,
    accountId,
    headers,
    isTrendingList = false,
    isGuestMode = null
) => ({
    type: SavedListActionTypes.GET_SAVED_LIST,
    deviceType,
    payload: {
        listId,
        params: { page, limit, sort },
        data,
        token,
        accountId,
        isTrendingList,
        isGuestMode,
    },
    headers,
});

export const deleteList = (listId, itemId, ppId, deleteAll = false, removedItem = {}) => {
    const payload = {
        listId,
        ...(ppId && { ppId }),
        ...(deleteAll && { deleteAll }),
        ...(itemId && { itemId: [itemId] }),
    };
    return {
        type: SavedListActionTypes.DELETE_SAVED_LIST,
        payload,
        removedItem,
    };
};

export const deleteSavedListItem = (id, itemId) => ({
    type: SavedListActionTypes.DELETE_SAVED_LIST_ITEM,
    payload: {
        id,
        itemId,
    },
});

export const toggleMostWantedInList = (listId, savedItemId, newValue) => {
    const payload = { listId };
    if (savedItemId) {
        payload.savedItemId = savedItemId;
    }
    if (newValue !== undefined && typeof newValue === 'boolean') {
        payload.newValue = newValue;
    }

    return {
        type: SavedListActionTypes.TOGGLE_MOST_WANTED_IN_LIST,
        payload,
    };
};

export const shareList = (listId, params, host, accountId, token = '') => ({
    type: SavedListActionTypes.SHARE_LIST,
    payload: { listId, params, host, accountId, token },
});

export const shareListReset = () => ({
    type: SavedListActionTypes.SHARE_LIST_RESET,
});

export const getListCategory = (listId, params, data, token, accountId, isGuestMode) => ({
    type: SavedListActionTypes.GET_LIST_CATEGORY,
    payload: { listId, params, data, token, accountId, isGuestMode },
});

export const updateMostWanted = (uuid, mostWanted) => ({
    type: SavedListActionTypes.UPDATE_MOST_WANTED,
    payload: { uuid, mostWanted },
});

export const addCartEvent = (data) => ({
    type: SavedListActionTypes.MYLIST_CART_ADD_ANALYTICS,
    analyticsData: data,
});

export const getSavedListsGuest = () => ({
    type: SavedListActionTypes.GET_SAVED_LIST_GUEST,
    payload: {},
});

export const trackIconEvent = (openModalShareList) => ({
    type: SavedListActionTypes.TRACK_ICON_EVENT,
    payload: { trackEvent: openModalShareList },
});

export const storeLastRemovedItem = (data) => ({
    type: SavedListActionTypes.STORE_LAST_REMOVED_ITEM,
    payload: data,
});

export const deleteLastRemovedItem = () => ({
    type: SavedListActionTypes.DELETE_LAST_REMOVED_ITEM,
});
